import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    iconWrapper: {
      width: "36px",
      height: "36px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    label: {
      fontSize: "14px",
      fontWeight: 500,
      color: "#000",
    },

    labelActive: {
      color: "#000",
    },

    labelInactive: {
      color: "#6B7280",
    },
  },
  componentName: "SectionCTAContent",
});
